import { render } from "./mailDetail.vue?vue&type=template&id=4f8c8dc8&scoped=true"
import script from "./mailDetail.vue?vue&type=script&lang=js"
export * from "./mailDetail.vue?vue&type=script&lang=js"

import "./mailDetail.vue?vue&type=style&index=0&id=4f8c8dc8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8c8dc8"]])

export default __exports__